
import detail from './detail'
import list from './list'

const news = {
  path: 'news',
  component: resolve => require(['../../../../pages/modules/news'], resolve),
  redirect: 'news/list',
  children: [
    detail,
    list
  ],
  meta: {
    requireAuth: true
  }
}

export default news
